export const costCentersPtBr = {
  common: {
    loading: 'Carregando...',
    save: 'Salvar',
    saving: 'Salvando...',
    cancel: 'Cancelar',
    edit: 'Editar',
    delete: 'Excluir',
    search: 'Pesquisar',
    noResults: 'Nenhum centro de custo encontrado.',
    change: 'Alterar',
    select: 'Selecionar',
  },
  errors: {
    loadCostCenters: 'Erro ao carregar centros de custo',
    loadDepartments: 'Erro ao carregar departamentos vinculados',
    saveCostCenter: 'Erro ao salvar centro de custo',
    linkDepartments: 'Erro ao vincular departamentos',
    unlinkDepartments: 'Erro ao desvincular departamentos',
    codeExists: 'Código já existe para esta entidade',
    loadUsers: 'Erro ao carregar usuários',
  },
  success: {
    costCenterCreated: 'Centro de custo criado com sucesso',
    costCenterUpdated: 'Centro de custo atualizado com sucesso',
    costCenterDeleted: 'Centro de custo excluído com sucesso',
  },
  pages: {
    costCenters: {
      title: 'Centros de Custo',
      createButton: 'Novo Centro de Custo',
      integrationMapping: 'Mapeamento de integrações',
      searchPlaceholder: 'Buscar centros de custo...',
      filters: {
        entity: {
          all: 'Todas entidades',
        },
        status: {
          label: 'Status',
          all: 'Todos',
          active: 'Ativos',
        },
      },
      stats: {
        costCenters: 'centros de custo',
        subCostCenters: 'sub-centros',
      },
      viewToggle: {
        expand: 'Expandir',
        collapse: 'Esconder',
      },
    },
  },
  form: {
    title: {
      create: 'Novo Centro de Custo',
      edit: 'Editar Centro de Custo',
    },
    description: 'Configure os detalhes do centro de custo.',
    sections: {
      basicInfo: {
        title: 'Informações Básicas',
        fields: {
          code: {
            label: 'Código',
            placeholder: 'Ex: CC-001',
          },
          name: {
            label: 'Nome',
            placeholder: 'Ex: Tesouraria',
          },
          description: {
            label: 'Descrição',
            placeholder: 'Descrição do centro de custo...',
          },
          parentCostCenter: {
            label: 'Centro de Custo Pai',
            placeholder: 'Nenhum (raiz)',
          },
        },
      },
      owner: {
        title: 'Responsável do Centro de Custo',
        subtitle: 'Usuário que aprova gastos',
        fields: {
          ownerUser: {
            label: 'Responsável',
            placeholder: 'Selecione um usuário',
            noOwner: 'Nenhum responsável definido',
          },
        },
      },
      limits: {
        title: 'Limite de Aprovação',
        subtitle: 'Valor máximo que o responsável pode aprovar',
        fields: {
          transactionLimit: {
            label: 'Limite por Transação',
            suffix: '/ transação',
            placeholder: '0,00',
            errors: {
              invalid: 'Valor inválido',
              negative: 'O valor não pode ser negativo',
            },
          },
          monthlyLimit: {
            label: 'Limite Mensal',
            suffix: '/ mês',
            placeholder: 'Sem limite',
            noLimit: 'Sem limite',
            errors: {
              invalid: 'Valor inválido',
              negative: 'O valor não pode ser negativo',
            },
          },
          warning: {
            transactionExceedsMonthly:
              'O limite por transação não pode ser maior que o limite mensal.',
          },
        },
      },
      departments: {
        title: 'Departamentos Vinculados',
        loading: 'Carregando departamentos vinculados...',
        empty: 'Nenhum departamento vinculado',
      },
      accountingUsage: {
        title: 'Uso contábil',
        payroll: {
          module: 'Folha de pagamento',
          unmapped: 'sem raiz',
          rootUnresolved: 'conta raiz configurada',
          viewAccounts: 'Ver contas',
        },
      },
      payrollGl: {
        title: 'Conta GL (folha)',
        subtitle: 'Conta contábil para lançamento da folha por centro de custo',
        placeholder: 'Selecione a conta raiz',
        linkToMapping: 'Também em Folha → Mapeamento CC/Depto',
      },
      aiContext: {
        title: 'Contexto para IA',
        subtitle: 'Opcional',
        placeholder: 'Informações contextuais para categorização e sugestões inteligentes...',
        generating: 'Gerando sugestão com IA...',
        regenerate: 'Gerar novamente',
        classificationContext: 'Contexto de Classificação',
      },
    },
  },
  detail: {
    departments: 'Departamentos',
    approvalLimit: 'Limite Aprovação',
    transactionLimit: 'Limite Transação',
    subCostCenters: 'Sub-Centros',
    parentCostCenter: 'Centro de Custo Pai',
    rootCostCenter: 'Centro de Custo Raiz',
    payrollGlAccount: 'Conta GL folha',
  },
  selector: {
    ownerUser: {
      label: 'Responsável do Centro de Custo',
      placeholder: 'Selecione um usuário',
      searchPlaceholder: 'Buscar por nome ou email...',
      noResults: 'Nenhum usuário encontrado.',
    },
  },
};
